import './bootstrap';
import 'admin-lte';

import { createApp,shallowRef,  ref, computed  } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'

import axios from 'axios';

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const vuetify = createVuetify({
	components,
	directives,
})

import  Form  from 'vform';
window.Form = Form;
//const form = new Form({ ... }

import vSelect from 'vue-select'
// Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css';

//Widget
import RightModalWidget from './components/widgets/RightModalWidget.vue'
import InfoWidget from './components/widgets/InfoWidget.vue'
import SearchWidget from './components/widgets/SearchWidget.vue'
import EditListWidget from './components/widgets/EditListWidget.vue'
import DropInput from './components/widgets/DropInput.vue'

//Page

import Footer from './components/footer.vue'

import {Bootstrap4Pagination} from 'laravel-vue-pagination'

import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';

//Page

//import login from './components/page/auth/Login.vue'

import Gate from "./Gate";
import routes from './routes';

import Swal from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const router = createRouter({
	routes,
	history: createWebHistory()
})


const app = createApp({
	data() {
		return {
			menu_site: '1',
		 }
	 }
	}
);

app.config.globalProperties.$gate = new Gate(window.user);
app.config.globalProperties.$axios = axios;


app.component("v-select", vSelect);
app.component('pagination', Bootstrap4Pagination)
app.component('vuetify', vuetify)

app.component('footers-page', require('./components/footer.vue').default)
app.component('info-widget', InfoWidget)
app.component('drop-widget', DropInput)
app.component('right-modal-widget', RightModalWidget)
app.component('search-widget', SearchWidget)
app.component('editlist-widget', EditListWidget)


//app.use(ToastPlugin);
app.use(ToastPlugin, {
	position: 'top-right'
})
app.use(vuetify)
app.use(router);
app.use(Swal);
//app.use(vSelect);
window.Swal =  app.config.globalProperties.$swal;


var vm = app.mount('#app')


